import { c as _c } from "react/compiler-runtime";
import type { ArticleTeaser } from "@modules/article/lib/teasers";
import Image from "next/image";
export interface ArticleCardProps {
  teaser: ArticleTeaser;
  href: string;
  readingTime: string | null;
}
const ArticleCard = t0 => {
  const $ = _c(19);
  const {
    teaser,
    href,
    readingTime
  } = t0;
  let t1;
  if ($[0] !== teaser.image) {
    t1 = teaser.image && <span className="relative block w-full aspect-[16/9]"><Image src={teaser.image} alt="" fill={true} sizes="(min-width: 960px) 25vw, (min-width: 640px) 50vw, 100vw" className="object-cover" /></span>;
    $[0] = teaser.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== teaser.category) {
    t2 = teaser.category && <span className="text-title-1 font-semibold text-neutral-425">{teaser.category}</span>;
    $[2] = teaser.category;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== teaser.title) {
    t3 = <span className="text-h5 font-semibold mt-2xs">{teaser.title}</span>;
    $[4] = teaser.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== teaser.summary) {
    t4 = teaser.summary && <span className="text-body-2 font-book text-neutral-425 mt-2xs line-clamp-2">{teaser.summary}</span>;
    $[6] = teaser.summary;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== readingTime) {
    t5 = readingTime && <span className="text-caption-1 font-book text-neutral-425 mt-auto pt-3s">{readingTime}</span>;
    $[8] = readingTime;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <span className="flex flex-col flex-1 p-3s">{t2}{t3}{t4}{t5}</span>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== href || $[16] !== t1 || $[17] !== t6) {
    t7 = <a href={href} className="flex flex-col h-full bg-neutral-0 border border-neutral-50 rounded-m overflow-hidden no-underline text-neutral-675 transition-shadow hover:shadow-3 focusable">{t1}{t6}</a>;
    $[15] = href;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export const ArticleCardList = t0 => {
  const $ = _c(4);
  const {
    cards
  } = t0;
  let t1;
  if ($[0] !== cards) {
    t1 = cards.map(_temp);
    $[0] = cards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="mt-2m grid gap-3s s:grid-cols-2 m:grid-cols-4 items-stretch list-none p-none m-none">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ArticleCard;
function _temp(card) {
  return <li key={card.teaser.slug}><ArticleCard {...card} /></li>;
}